import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="fxday">
                1.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxday')}
            </Typography>
            <p><strong>{translate('fxday')}</strong> 月の日付を表す 1 ～ 31 の数値を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>暦日</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Day("1990-10-10") returns 10</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxdayname">
                2.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxdayname')}
            </Typography>
            <p><strong>{translate('fxdayname')}</strong> 曜日の完全な名前のテキストを返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>暦日</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. DayName("1990-10-10") returns Wednesday</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxdayofweek">
                3.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxdayofweek')}
            </Typography>
            <p><strong>{translate('fxdayofweek')}</strong> 曜日を表す数値を返します。数字の 1 は日曜日を表し、2 は月曜日を表し、3 は火曜日を表します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>暦日</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. DayOfWeek("1990-10-10") returns 3</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxdayofyear">
                4.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxdayofyear')}
            </Typography>
            <p><strong>{translate('fxdayofyear')}</strong> 年の初めからの日数を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>暦日</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. DayOfYear("1990-10-10") returns 283</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxmonth">
                5.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxmonth')}
            </Typography>
            <p><strong>{translate('fxmonth')}</strong> 月を表す 1 ～ 12 の数値を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>暦日</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Month("1990-10-10") returns 10</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxmonthname">
                6.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxmonthname')}
            </Typography>
            <p><strong>{translate('fxmonthname')}</strong> 月の名前を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>暦日</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. MonthName("1990-10-10") returns October</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxweekofyear">
                7.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxweekofyear')}
            </Typography>
            <p><strong>{translate('fxweekofyear')}</strong> その年の 1 月 1 日以降の週数を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>暦日</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. WeekOfYear("1990-10-10") returns 41</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxyear">
                8.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxyear')}
            </Typography>
            <p><strong>{translate('fxyear')}</strong> 年を表す数値を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('date')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>暦日</td>
                                <td>"1990-10-10"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Year("1990-10-10") returns 1990</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxsetdate">
                9.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxsetdate')}
            </Typography>
            <p><strong>{translate('fxsetdate')}</strong> 指定された形式でカレンダーの日付を返します。</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('year')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>年</td>
                                <td>1990</td>
                            </tr>
                            <tr>
                                <td>{translate('month')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="number" />
                                </td>
                                <td>月</td>
                                <td>10</td>
                            </tr>
                            <tr>
                                <td>{translate('day')}<span>*</span></td>
                                    <ParametersTypeValue type="number" />
                                <td>暦日</td>
                                <td>10</td>
                            </tr>
                            <tr>
                                <td>{translate('format')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>返される結果の形式</td>
                                <td>"YYYY-MM-DD"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. SetDate(1990, 10, 10, "YYYY-MM-DD") returns "1990-10-10"</div>
                    <div>2. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) , Day(GetCurrentDate(7)) - 1 , "YYYY-MM-DD") returns yesterday (Vietname time).</div>
                    <div>3. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) , Day(GetCurrentDate(7)) + 1 , "YYYY-MM-DD") returns tomorrow (Vietname time).</div>
                    <div>4. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) , 1 , "YYYY-MM-DD") returns the first day of this month (Vietname time).</div>
                    <div>5. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) + 1 , 0 , "YYYY-MM-DD") returns the last day of this month (Vietname time).</div>
                    <div>6. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) - 1 , 1 , "YYYY-MM-DD") returns the first day of last month (Vietname time).</div>
                    <div>7. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) , 0 , "YYYY-MM-DD") returns the last day of last month (Vietname time).</div>
                    <div>8. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) + 1 , 1 , "YYYY-MM-DD") returns the first day of next month (Vietname time).</div>
                    <div>9. SetDate(Year(GetCurrentDate(7)) , Month(GetCurrentDate(7)) + 2 , 0 , "YYYY-MM-DD") returns the last day of next month (Vietname time).</div>
                </div>
            </ul>
        </Box>
    );
}
export default withTranslate(En);